import { defaultRules, type TapRules } from "./tap";

/**
 * Reads tap rules from the client config (`economy.coinsPerTap`, `mechanics.comboWindowMs`,
 * `mechanics.comboMultiplierMax`). Missing or invalid values keep the fallback.
 */
export function rulesFromConfig(data: unknown, fallback: TapRules = defaultRules): TapRules {
  const economy = section(data, "economy");
  const mechanics = section(data, "mechanics");
  return {
    coinsPerTap: int(economy.coinsPerTap, 1, 1_000_000) ?? fallback.coinsPerTap,
    comboWindowMs: int(mechanics.comboWindowMs, 0, 60_000) ?? fallback.comboWindowMs,
    comboMultiplierMax: int(mechanics.comboMultiplierMax, 1, 1_000) ?? fallback.comboMultiplierMax,
  };
}

function section(data: unknown, name: string): Record<string, unknown> {
  const value = isObject(data) ? data[name] : undefined;
  return isObject(value) ? value : {};
}

function isObject(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

function int(value: unknown, min: number, max: number): number | undefined {
  return Number.isSafeInteger(value) && (value as number) >= min && (value as number) <= max ? (value as number) : undefined;
}
